import React from 'react';
import { Link } from 'react-router-dom';

const featuredTournament = {
  title: 'Orjan Lindroth Memorial Open Chess Tournament',
  date: 'August 2026',
  host: 'The Bahamas Chess Institute',
  details:
    'An upcoming open tournament hosted by The Bahamas Chess Institute. Venue, format and registration details can be added here as they are confirmed.',
};

const offerings = [
  {
    title: 'Private Lessons',
    text: 'Private one-to-one chess instruction and structured training for players looking to build confidence, understanding and competitive strength.',
    href: '/lessons-and-programs',
  },
  {
    title: 'Scholastic Programs',
    text: 'Schools can partner with the Institute for structured scholastic chess programs, including group lessons delivered through an organized after-school format.',
    href: '/lessons-and-programs',
  },
  {
    title: 'About the Institute',
    text: 'Learn more about the Institute, its founder and its role in developing chess in The Bahamas.',
    href: '/about',
  },
];

const instituteHighlights = [
  {
    title: 'Founder and Leadership',
    text: 'The Institute was founded by FIDE Master Cecil Moncur and is guided by a long-term commitment to structured chess development in The Bahamas.',
  },
  {
    title: 'National Development Focus',
    text: 'The organization supports chess growth through lessons, scholastic programming and event activity that serve students, families and the wider community.',
  },
  {
    title: 'Competitive Event Experience',
    text: 'The Institute has hosted notable invitationals and classic-format events and continues to support opportunities for strong local competition.',
  },
];

function TournamentsPage() {
  return (
    <div className="page-stack">
      <section className="hero-grid hero-grid-wide">
        <div className="hero-copy">
          <div className="eyebrow">Developing Minds Through Chess</div>
          <h1>The Bahamas Chess Institute</h1>
          <p className="hero-text">
            Founded by FIDE Master Cecil Moncur, The Bahamas Chess Institute supports chess
            development in The Bahamas through private lessons, school-based scholastic programs
            and competitive tournaments.
          </p>

          <div className="inline-note-row">
            <div className="inline-note">
              <span className="inline-note-label">Founded by</span>
              <strong>FM Cecil Moncur</strong>
            </div>
            <div className="inline-note">
              <span className="inline-note-label">Focus</span>
              <strong>Lessons, school programs and tournaments</strong>
            </div>
          </div>
        </div>

        <aside className="surface-card hero-panel">
          <div className="pill-tag">Featured event</div>
          <h2>{featuredTournament.title}</h2>
          <p>{featuredTournament.details}</p>

          <div className="detail-list compact-detail-list">
            <div>
              <span className="detail-label">Presented by</span>
              <span>{featuredTournament.host}</span>
            </div>
            <div>
              <span className="detail-label">When</span>
              <span>{featuredTournament.date}</span>
            </div>
            <div>
              <span className="detail-label">Details</span>
              <span>More information to be announced</span>
            </div>
          </div>

          <div className="button-row">
            <a className="primary-btn" href="mailto:bahamaschessinstitute@gmail.com">
              Contact Institute
            </a>
          </div>
        </aside>
      </section>

      <section className="content-section">
        <div className="section-heading">
          <div className="eyebrow">Explore</div>
          <h3>Instruction for individuals. Programs for schools.</h3>
          <p>
            The Institute provides professional chess instruction while also supporting schools
            through structured scholastic programming and the wider chess community through events.
          </p>
        </div>

        <div className="card-grid three-up">
          {offerings.map((item) => (
            <Link key={item.title} to={item.href} className="card-link">
              <article className="surface-card info-card clickable-card">
                <h4>{item.title}</h4>
                <p>{item.text}</p>
                <span className="card-link-text">Learn more</span>
              </article>
            </Link>
          ))}
        </div>
      </section>

      <section className="content-section">
        <div className="section-heading">
          <div className="eyebrow">Institute highlights</div>
          <h3>Built on teaching, credibility and chess development.</h3>
          <p>
            The Bahamas Chess Institute combines coaching leadership, community development and
            event experience to strengthen chess in The Bahamas.
          </p>
        </div>

        <div className="card-grid three-up">
          {instituteHighlights.map((item) => (
            <article key={item.title} className="surface-card info-card highlight-card">
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default TournamentsPage;
